
<!-- Usage:
   <fractionning-dialog v-if="showModal" @close="showModal=false" v-model="fract" />
-->

<template>
   <transition name="modal">
      <div class="modal-mask">
         <div class="modal-wrapper">
            <div class="modal-container">
               <v-card>
                  <v-card-title class="headline grey lighten-2">{{ title }}</v-card-title>
                  <v-card-text>
                     <v-container grid-list-md>
                        <v-layout wrap>

                           <v-flex xs12>
                              <v-menu
                                 lazy
                                 :close-on-content-click="false"
                                 v-model="menu"
                                 transition="scale-transition"
                                 offset-y
                                 full-width
                                 :nudge-right="40"
                                 min-width="290px"
                              >
                                 <v-text-field
                                    slot="activator"
                                    label="Date"
                                    :value="formattedEditedDate"
                                    :disabled="disableDate"
                                    readonly
                                 ></v-text-field>
                                 <v-date-picker
                                    v-model="pickerDate"
                                    @input="value.date = pickerDate; menu = false"
                                    :min="disableDate ? today : null"
                                    :max="today"
                                    locale="fr-FR"
                                    :first-day-of-week="1"
                                    scrollable
                                 >
                                    <!--v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu = false">Annuler</v-btn>
                                    <v-btn flat color="primary" @click="value.date = pickerDate; menu = false">OK</v-btn-->
                                 </v-date-picker>
                              </v-menu>
                           </v-flex>

                           <v-flex xs12>
                              <v-select
                                 v-model="value.mealPresenceArray"
                                 :items="mealTypes"
                                 item-text="name"
                                 item-value="index"
                                 attach
                                 chips
                                 label="Repas de la journée"
                                 multiple
                                 @input="$v.value.mealPresenceArray.$touch()"
                                 blur="$v.value.mealPresenceArray.$touch()"
                                 :errorMessages="mealPresenceArrayErrors"
                              ></v-select>
                           </v-flex>

                           <v-flex xs12 sm8>
                              <v-checkbox
                                 v-model="isSurvey"
                                 label="Relevé alimentaire"
                              ></v-checkbox>
                           </v-flex>

                           <v-flex xs12 sm8 v-if="isSurvey">
                              <v-select
                                 v-model="value.surveyIndex"
                                 label="Type de relevé"
                                 :items="surveyTypes"
                                 item-text="name"
                                 item-value="index"
                                 @input="$v.value.surveyIndex.$touch()"
                                 blur="$v.value.surveyIndex.$touch()"
                                 :errorMessages="surveyIndexErrors"
                              ></v-select>
                           </v-flex>

                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions>
                     <v-spacer></v-spacer>
                     <v-btn color="brown darken-2" flat :disabled="!formValid" @click.native="close(); emitValue()">OK</v-btn>
                     <v-btn color="brown darken-2" flat @click.native="close(); emitCancel()">Annuler</v-btn>
                  </v-card-actions>
               </v-card>
            </div>
         </div>
      </div>
   </transition>
</template>

<script>
   import config from '@/config'
   import moment from 'moment'
   import { required } from 'vuelidate/lib/validators'

   export default {

      props: {
         title: String,
         disableDate: { type: Boolean, default: true },
         value: Object, // for v-model 2-way binding
      },

      mounted() {
         if (this.value.surveyIndex !== null) {
            this.isSurvey = true
         }
      },

      data () {
         return {
            menu: false,
            pickerDate: this.value.date || new Date(),
            isSurvey: false,
         }
      },

      computed: {
         today() {
            return moment().format()
         },
         formattedEditedDate() {
            return moment(this.value.date).format("Do MMMM YYYY")
         },
         mealTypes() {
            return config.MEAL_TYPE_LIST.map(index => config.MEAL_TYPES[index])
         },
         surveyTypes() {
            return config.MEAL_SURVEY_LIST.map(index => config.MEAL_SURVEYS[index])
         },
         mealPresenceArrayErrors () {
            const errors = []
            if (!this.$v.value.mealPresenceArray.$dirty) return errors
            !this.$v.value.mealPresenceArray.required && errors.push("Un repas au moins est obligatoire")
            return errors
         },
         surveyIndexErrors () {
            const errors = []
            if (!this.$v.value.surveyIndex.$dirty) return errors
            !this.$v.value.surveyIndex.required && errors.push("Le type du relevé est obligatoire")
            return errors
         },
         formValid () {
            if (!this.$v.value.mealPresenceArray.required) return false
            if (this.isSurvey && !this.$v.value.surveyIndex.required) return false
            return true
         },
      },

      methods: {
         close() {
            this.$emit('close')
         },
         emitValue() {
            // update surveyIndex
            if (!this.isSurvey) this.value.surveyIndex = null
            // reorder mealPresenceArray
            this.value.mealPresenceArray.sort((a, b) => a - b)
            // emit 'input' event for fractionning value
            this.$emit('input', this.value)
         },
         emitCancel() {
            this.$emit('cancel')
         },
      },

      // vuelidate validators (as a function)
      validations() {
         let validators = {
            value: {
               mealPresenceArray: {
                  required,
               },
            }
         }
         if (this.isSurvey) {
            Object.assign(validators.value, {
               surveyIndex: {
                  required,
               },
            })
         }
         return validators
      },

   }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>




// WEBPACK FOOTER //
// FractionningDialog.vue?1a8c43c1